<template>
  <div ref="previewModal" v-on:click="close" class="modal">
    <span class="close" v-on:click="close">&times;</span>
    <img class="modal-content" v-on:click="clickImage" :src="src" />
    <div id="caption">{{ alt }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      display: false,
    };
  },

  methods: {
    clickImage(e) {
      e.stopPropagation();
    },
    close() {
      this.display = false;
      this.handleOnClose(this.display);
    },
  },
  props: {
    handleOnClose: {
      type: Function,
      required: false,
      default: () => {},
    },
    show: Boolean,
    src: String,
    alt: String,
  },
  mounted() {
    this.display = this.show;
  },
  watch: {
    show: {
      handler(val) {
        this.display = val;
      },
    },
    display: {
      handler(val) {
        if (val) {
          this.$refs.previewModal.style.display = "block";
          return;
        }
        this.$refs.previewModal.style.display = "none";
      },
    },
  },
};
</script>
<style lang="scss">
.modal {
  display: none;
  position: fixed;
  z-index: 9999;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.9);
}

.modal-content {
  margin: auto;
  display: block;

  max-width: 650px;
  max-height: 600px;
}

#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

.modal-content,
#caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px !important;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
  }
}
</style>
